
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ProjectDetail from '@/components/projects/ProjectDetail';

const ProjectDetailPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow bg-gray-50 px-4 py-8 md:px-8">
        <div className="container mx-auto max-w-6xl">
          <ProjectDetail />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ProjectDetailPage;
